<div
  class="tw-flex"
  *ngIf="allowPublic"
>
  <div class="tw-flex tw-flex-1">
    <p-toggleswitch
      *ngIf="!loadingPublicUrl"
      [formControl]="sharePublicControl"
      class="tw-flex tw-self-center"
    />
    <div
      *ngIf="loadingPublicUrl"
      class="tw-flex tw-items-center"
    >
      <span class="tw-text-xl tw-text-gray-600 fa-spin fa-solid fa-circle-notch"></span>
    </div>
    <div class="tw-ml-2">
      <h4 class="tw-text-lg tw-mb-0">Share via Public Link</h4>
      <span
        *ngIf="!passwordControl?.value?.length"
        class="tw-text-sm"
      >
        Anyone with the link can access this {{ type.toLowerCase() }}
      </span>
      <span
        *ngIf="passwordControl?.value?.length > 0"
        class="tw-text-sm"
      >
        Anyone with the link can access this {{ type.toLowerCase() }} if the password is provided
      </span>
    </div>
  </div>
  <p-button
    [label]="publicUrlCopied ? 'Copied!' : 'Copy public link'"
    icon="fa fa-copy"
    severity="secondary"
    [outlined]="!publicUrlCopied"
    (onClick)="copyLink(publicUrl)"
    class="tw-content-center"
    *ngIf="sharePublicControl.value && publicUrl"
  ></p-button>
</div>

<div
  class="tw-flex tw-flex-col tw-mt-4 tw-ml-5"
  *ngIf="sharePublicControl.value && allowPublic && publicUrl"
>
  <div class="tw-flex tw-items-center">
    <p-checkbox
      [formControl]="passwordProtectionControl"
      inputId="passwordProtection"
      binary="true"
    />
    <label
      for="passwordProtection"
      class="tw-ml-2"
    >
      Password protection
    </label>
    <p-tag
      *ngIf="hasExistingPassword"
      class="tw-ml-2"
      [value]="passwordStatus === 'updated' ? 'Updated!' : 'Enabled'"
      severity="success"
      [icon]="passwordStatus === 'updated' ? '' : 'fas fa-check'"
    ></p-tag>
  </div>
  <div
    class="tw-flex tw-items-center tw-gap-2 tw-mt-3 tw-ml-6 tw-justify-between"
    *ngIf="passwordProtectionControl.value"
  >
    <div class="tw-flex tw-flex-col tw-gap-2">
      <p-button
        *ngIf="hasExistingPassword && passwordMode === 'summary'"
        label="Set new password"
        severity="secondary"
        [outlined]="true"
        (onClick)="startPasswordChange()"
      ></p-button>
      <div
        class="tw-flex tw-items-center tw-gap-2"
        *ngIf="passwordMode === 'edit'"
      >
        <p-password
          [formControl]="passwordControl"
          [toggleMask]="true"
          [feedback]="false"
          [placeholder]="hasExistingPassword ? 'Enter password' : 'Enter new password'"
          inputStyleClass="tw-w-80"
        />
        <p-button
          label="Save"
          [loading]="passwordStatus === 'saving'"
          severity="primary"
          [outlined]="true"
          [disabled]="!passwordControl.value || passwordControl.invalid"
          (onClick)="savePassword()"
        ></p-button>
        <p-button
          *ngIf="hasExistingPassword"
          label="Cancel"
          severity="secondary"
          [outlined]="true"
          (onClick)="cancelPasswordChange()"
        ></p-button>
      </div>
      <small
        *ngIf="passwordMode === 'edit'"
        class="tw-text-sm tw-text-gray-500 tw-ml-1"
      >
        Minimum 8 characters
      </small>
    </div>

    <p-button
      *ngIf="passwordSavedInThisSession && passwordMode === 'summary'"
      [label]="passwordCopied ? 'Copied!' : 'Copy password'"
      icon="fa fa-copy"
      severity="secondary"
      [outlined]="!passwordCopied"
      [disabled]="!passwordControl.value || passwordControl.invalid"
      (onClick)="copyPassword()"
    ></p-button>
  </div>
  <p-message
    *ngIf="passwordSavedInThisSession && passwordMode === 'summary'"
    text="Please take note of your password — for security reasons, it won't be visible once you close this window."
    severity="warn"
    [closable]="false"
    class="tw-mt-2 tw-ml-6 tw-block"
  />
  <small
    class="tw-text-red-500 tw-mt-1 tw-ml-6 tw-block"
    *ngIf="passwordProtectionControl.value && passwordControl.invalid && passwordControl.touched"
  >
    Password must be at least {{ DEFAULT_PASSWORD_LENGTH }} characters long
  </small>
</div>

<ng-container *ngComponentOutlet="urlModifierComponent" />

<p-divider *ngIf="allowPublic" />

<div
  class="tw-flex tw-pb-2"
  *ngIf="allowTeamSharing"
>
  <div class="tw-flex tw-flex-col tw-flex-1 tw-mb-1">
    <h4 class="tw-mb-0">Share with team members</h4>
    <span class="tw-text-sm">The team members will need to login before accessing the {{ type.toLowerCase() }}</span>
  </div>
  <p-button
    [label]="shareUrlCopied ? 'Copied!' : 'Copy private link'"
    icon="fa fa-copy"
    severity="secondary"
    [outlined]="!shareUrlCopied"
    (onClick)="copyLink(shareUrl)"
    class="tw-content-center"
    *ngIf="shareUrl"
  ></p-button>
</div>
<div
  class="tw-flex tw-flex-col tw-border tw-border-gray-200 tw-border-solid tw-rounded-lg tw-p-4 tw-mb-4 tw-max-h-64 tw-overflow-y-auto"
  *ngIf="sharedUsersAndSuites.length"
>
  <div
    *ngFor="let userOrSuite of sharedUsersAndSuites; let i = index; let last = last; trackBy: trackBySharedItems"
    class="tw-flex"
    [ngClass]="{
      'tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-b tw-border-gray-200 tw-border-solid tw-mb-4 tw-pb-4': !last
    }"
  >
    <i
      [ngClass]="userOrSuite.type === 'user' ? 'fa-user' : 'fa-user-group'"
      class="fa-solid tw-content-center tw-text-gray-500"
    ></i>
    <div class="tw-text-gray-600 tw-content-center tw-flex-1 tw-pl-4">
      <h5 class="tw-mb-0">{{ userOrSuite.name }}</h5>
      <p
        class="tw-mb-0 tw-text-sm"
        *ngIf="userOrSuite.email"
      >
        {{ userOrSuite.email }}
      </p>
    </div>
    <p-select
      [(ngModel)]="dropdownCustomModel[userOrSuite.id]"
      [loading]="!removingAllUsersAndSuites && updatingUserPermissions[userOrSuite.id]"
      loadingIcon=" fa-solid fa-circle-notch fa-spin"
      (onChange)="dropdownModelChange($event?.value?.value, userOrSuite)"
      [options]="dropdownCustomOptions"
      optionLabel="name"
      appendTo="body"
    ></p-select>
  </div>
</div>

<ng-container *ngIf="allowTeamSharing">
  <div class="tw-flex tw-flex-col">
    <p-multiSelect
      [options]="groupedUsersAndSuites"
      [group]="true"
      [showClear]="true"
      [filter]="true"
      [filterBy]="'name,email,label'"
      [formControl]="usersAndSuitesControl"
      [loading]="loadingUsersAndSuites"
      loadingIcon=" fa-solid fa-circle-notch fa-spin"
      [placeholder]="sharedUsersAndSuites?.length ? 'Add users and suites' : 'Select users and suites'"
      (onClear)="usersAndSuitesCleared()"
      styleClass="tw-w-full"
      class="tw-w-full"
      optionLabel="name"
    >
      <ng-template
        pTemplate="item"
        let-item
      >
        <span>{{ item.name }}</span>
        <span
          class="tw-ml-1 tw-text-gray-500"
          *ngIf="item.email"
        >
          ({{ item.email }})
        </span>
      </ng-template>
    </p-multiSelect>
  </div>
  <div *ngIf="usersAndSuitesControl.value?.length">
    <textarea
      [(ngModel)]="note"
      placeholder="Add a note to invite"
      pTextarea
      class="tw-w-full tw-mt-4 tw-h-20"
    ></textarea>
  </div>
</ng-container>

<p-divider *ngIf="allowTeamSharing" />

<div
  *ngIf="!loadingPublicUrl && !loadingUsersAndSuites"
  class="tw-flex tw-flex-col"
>
  <h4>Sharing Permissions</h4>
  <div
    [formGroup]="permissionsForm"
    class="tw-flex tw-flex-col tw-gap-2"
  >
    <div
      class="tw-flex"
      [ngClass]="{ 'tw-hidden': type === SNAPSHOT }"
    >
      <p-checkbox
        formControlName="dates"
        inputId="dates"
        name="dates"
        binary="true"
      />
      <label
        for="dates"
        class="tw-ml-2"
      >
        Allow viewers to adjust date range
      </label>
    </div>
    <div
      *ngIf="type === REPORT || type === DASHBOARD"
      class="tw-flex"
    >
      <p-checkbox
        formControlName="global_filters"
        inputId="globalFilters"
        name="globalFilters"
        binary="true"
      />
      <label
        for="globalFilters"
        class="tw-ml-2"
      >
        <span *ngIf="type === DASHBOARD">Show applied global and page filters</span>
        <span *ngIf="type === REPORT">Show applied global filters</span>
      </label>
    </div>
  </div>
  <div
    *ngIf="type === SNAPSHOT"
    class="tw-flex tw-flex-col"
    [formGroup]="snapshotPermissionsForm"
  >
    <div class="tw-flex tw-my-2">
      <p-checkbox
        formControlName="comparisons"
        inputId="comparisons"
        name="comparisons"
        binary="true"
      />
      <label
        for="comparisons"
        class="tw-ml-2"
      >
        Comparisons
      </label>
      <i
        class="fa-solid fa-circle-info tw-ml-2"
        pTooltip="Allow viewers to compare different date ranges"
      ></i>
    </div>
    <div class="tw-font-semibold tw-my-2">Views</div>
    <div class="tw-flex tw-flex-col tw-gap-2">
      <p-select
        [formControl]="snapshotPermissionsForm.get('views')"
        [options]="viewOptions"
        styleClass="tw-w-full"
      ></p-select>
    </div>
    <ng-container *ngIf="datasets?.length">
      <div class="tw-font-semibold tw-mt-4 tw-mb-2">Vendors</div>
      <div
        class="tw-flex tw-flex-col tw-border tw-border-gray-200 tw-border-solid tw-rounded-lg tw-p-4 tw-bg-gray-50 tw-mb-4 tw-max-h-48 tw-overflow-y-auto"
      >
        <ng-container formGroupName="datasets">
          <div
            class="tw-flex tw-mb-4"
            *ngFor="let dataset of datasets"
          >
            <p-checkbox
              [formControlName]="dataset"
              [inputId]="dataset"
              [name]="dataset"
              binary="true"
            />
            <label
              [for]="dataset"
              class="tw-ml-2 tw-capitalize"
            >
              {{ getDatasetDisplayName(dataset) }}
            </label>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
<div class="tw-flex tw-flex-col tw-pt-5">
  <div
    class="tw-flex tw-gap-2 tw-justify-end"
    *ngIf="usersAndSuitesControl.value?.length"
  >
    <p-button
      label="Share without invite"
      severity="primary"
      outlined="true"
      [loading]="sendingInvites"
      (onClick)="sendInvite(true)"
    ></p-button>
    <p-button
      label="Share and send invite"
      severity="primary"
      [loading]="sendingInvites"
      (onClick)="sendInvite(false)"
    ></p-button>
  </div>
  <div
    class="tw-flex tw-gap-2 tw-justify-end"
    *ngIf="!usersAndSuitesControl.value?.length"
  >
    <p-button
      [loading]="removingAllUsersAndSuites"
      label="Remove all"
      severity="danger"
      outlined="true"
      (onClick)="removeAllUsersAndSuites()"
      *ngIf="sharedUsersAndSuites.length"
    ></p-button>
    <p-button
      label="Done"
      severity="secondary"
      outlined="true"
      (onClick)="close()"
      [disabled]="
        (public && type === SNAPSHOT && snapshotPermissionsForm.invalid) ||
        (public && passwordProtectionControl.value && passwordMode === 'edit')
      "
    ></p-button>
  </div>
</div>
